<template>
  <div class="dnnCloud-sys-box">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">轮播图</el-menu-item>
      <el-menu-item index="2" >系统参数</el-menu-item>
    </el-menu>

    <div class="sys-tab-item" v-show="showLBT">
      <UrlsLBT></UrlsLBT>
    </div>

    <div class="sys-tab-item" v-show="showURL">
      <UrlsNumber></UrlsNumber>
    </div>

    <!-- <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
      </div>
    </div> -->
  </div>
</template>
<script>
import UrlsNumber from '../urls/UrlsNumber'
import UrlsLBT from '../urls/UrlsLBT'
export default {
  data(){
    return{
      activeIndex: '',
      showLBT:true,
      showURL:false,
    }
  },
  methods: {
    
    handleSelect(key, keyPath) {
      this.showURL = false;
      this.showLBT = false;
      if(key == '1'){
        this.showLBT = true;
        sessionStorage.setItem('admin_menu', '1');
      }else if(key == '2'){
        this.showURL = true;
        sessionStorage.setItem('admin_menu', '2');
      }
      // console.log(key, keyPath);
    }
  },
  mounted(){
    this.activeIndex = sessionStorage.getItem('admin_menu');
    if(this.activeIndex == '2'){
      this.showLBT = false;
      this.showURL = true;
      sessionStorage.setItem('admin_menu', 2);
    }else{
      this.showLBT = true;
      this.showURL = false;
      sessionStorage.setItem('admin_menu', 1);
    }
  },
  components: {
    UrlsLBT,
    UrlsNumber,
  },
}
</script>
<style lang="scss">
.dnnCloud-sys-box {
  width: 100%;
  height: 100%;
  .sys-tab-item {
    width: 100%;
    height: calc(100% - 61px);
  }
}
</style>



// WEBPACK FOOTER //
// Urls.vue?56e95c16